//(function (x) {
//    var myNavBar = {
//        flagAdd: true,
//        elements: [],
//        init: function (elements) {
//            this.elements = elements;
//        },
//        add: function () {
//            if (this.flagAdd) {
//                for (var i = 0; i < this.elements.length; i++) {
//                    if (!$("body").hasClass("yedioth")) {
//                        x(this.elements[i]).addClass('inverse');
//                    }
//                    x(this.elements[i]).addClass('fixed-theme');
//                }
//                this.flagAdd = false;
//            }
//        },
//        remove: function () {
//            for (var i = 0; i < this.elements.length; i++) {
//                if (!$("body").hasClass("yedioth")) {
//                    x(this.elements[i]).removeClass('inverse');
//                }
//                x(this.elements[i]).removeClass('fixed-theme');
//            }
//            this.flagAdd = true;
//        }
//    };

//    myNavBar.init([
//        "header.main"
//    ]);

//    function offSetManager() {
//        var yOffset = 0;
//        var currYOffSet = window.pageYOffset;

//        if (yOffset < currYOffSet) {
//            myNavBar.add();
//        }
//        else if (currYOffSet == yOffset) {
//            myNavBar.remove();
//        }

//    }

//    window.onscroll = function (e) {
//        offSetManager();
//    }

//    offSetManager();
//})(jQuery);


//////////////////
// WEBPACK FOOTER
// ../scripts/yit/sticky-menu.js
// module id = 7
// module chunks = 0